import {createAction} from '@reduxjs/toolkit';

/**
 * Action to toggle whether custom event offsets are applied across the batch.
 * When enabled, the offsets override the pricing-rule defaults for every
 * selected event; when disabled, the pricing-rule offsets are used.
 */
export const setEventOffsetsEnabled = createAction<boolean>(
    'compPass/setEventOffsetsEnabled'
);

/**
 * Action to set the "before" custom event offset (`"HH:MM"`).
 */
export const setEventStartsOffset = createAction<string>(
    'compPass/setEventStartsOffset'
);

/**
 * Action to set the "after" custom event offset (`"HH:MM"`).
 */
export const setEventEndsOffset = createAction<string>(
    'compPass/setEventEndsOffset'
);
